export default __webpack_public_path__ + "static/media/holly_jolly_christmas_2023.6fc060f1.png";